// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageReportBody = {
  messageId: string;
  reason: "spam" | "harassment" | "hate" | "other";
  details?: string | null;
};

export type typeMessageReportOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { reportId: string };
};

export type typeMessageReportOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageReportOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageReportOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageReportBody = {
  type: "object",
  properties: {
    messageId: { type: "string", maxLength: 3000, minLength: 1 },
    reason: { type: "string", enum: ["spam", "harassment", "hate", "other"] },
    details: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["messageId", "reason"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageReport(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageReportBody);
  }

  return async function postMessageReport(
    payload: typeMessageReportBody,
  ): Promise<typeMessageReportOutput200 | typeMessageReportOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageReport" failed before calling the network. #d7d2bdf6d90c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d7d2bdf6d90c" },
        },
        data: null,
      } as typeMessageReportOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message/report`,
      httpMethod: "POST",
      options,
    })) as typeMessageReportOutput200 | typeMessageReportOutput400;
  };
}
